// Texts for the world 'breakfast': the name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Morgenmad',
    levels: {
      'first-roll': { title: 'Første rul' },
      'bounce': { title: 'Hop!' },
      'banana': { title: 'Bananen' },
      'seesaw': { title: 'Vippen' },
      'paint-bucket': { title: 'Malerspanden' },
      'toaster': { title: 'Brødristeren' },
      'cut-the-rope': { title: 'Klip snoren' },
      'three-peas': { title: 'Tre ærter' },
      'window': { title: 'Vinduet' },
      'pulley': { title: 'Trissen' },
      'chain-reaction': { title: 'Kædereaktion' },
      'morning-bell': { title: 'Morgenklokken' },
    },
  },
  en: {
    name: 'Breakfast',
    levels: {
      'first-roll': { title: 'First roll' },
      'bounce': { title: 'Bounce!' },
      'banana': { title: 'The banana' },
      'seesaw': { title: 'The seesaw' },
      'paint-bucket': { title: 'The paint pot' },
      'toaster': { title: 'The toaster' },
      'cut-the-rope': { title: 'Cut the rope' },
      'three-peas': { title: 'Three peas' },
      'window': { title: 'The window' },
      'pulley': { title: 'The pulley' },
      'chain-reaction': { title: 'Chain reaction' },
      'morning-bell': { title: 'The morning bell' },
    },
  },
});
